// Full screen view with the wallaby header on top
import React from 'react'

import { globalStyleVars } from '#util/constants'

import styles from './AppWithHeader.module.css'

// TODO: simplify layout styles and lean more heavily on mantine?
export const AppWithHeader = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.root} style={globalStyleVars}>
    {children}
  </div>
)
